<div class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text" i18n="@@app.term.visit.portfolio.view.title.label">Listine</h3>
            </div>
        </div>
        <div class="m-portlet__head-tools">
            <ul class="m-portlet__nav">
                <li *ngIf="!isHDView && isEditable" class="m-portlet__nav-item">
                    <a
                        *ngIf="createNewItems?.length > 0"
                        ngbTooltip="Dodaj listino"
                        style="cursor: pointer"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        class="m-portlet__nav-link m-portlet__nav-link--icon mf-t-openPopup"
                    >
                        <i class="la la-plus"></i>
                    </a>

                    <div
                        x-placement="bottom-end"
                        style="position: absolute; transform: translate3d(-64px, 70px, 0px); top: 0px; left: 0px; will-change: transform"
                        class="dropdown-menu dropdown-menu-right"
                    >
                        <a *ngFor="let item of createNewItems" (click)="popupPaper(item.paperType)" class="dropdown-item cursor">
                            {{ item.name }}
                        </a>
                    </div>
                </li>
                <li *ngIf="termData?.visitId && isHDView && !termData?.visitEndDate">
                    <button (click)="this.concludeVisit()" class="btn btn-outline-warning m-btn m-btn--pill btn-block my-2">
                        <span>
                            <span>Zaključi obravnavo</span>
                        </span>
                    </button>
                </li>
                <li *ngIf="isHDView && termData?.visitEndDate">
                    <div class="btn btn-outline-success m-btn m-btn--pill btn-block my-2">
                        <span>
                            <span>Obravnava zaključena</span>
                        </span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="m-portlet__body pb-2 pt-2">
        <ng-container *ngIf="type === pfType.TERM && isHDActive">
            <div class="d-flex justify-content-center mf-portfolio">
                <div class="text-center w-100 mb-auto">
                    <div (click)="popupPaper('MEDIFIT_MEDICAL_REPORT')" class="mf-portfolio__item text-center mx-auto">
                        <i class="la mf-i-hd-referral la-4x"></i>
                    </div>
                    <div class="text-uppercase">MF Medical izvid</div>
                </div>
            </div>
            <div *ngIf="showHDWarning" class="d-flex justify-content-center text-warning mt-2" i18n="@@6044028283912192">
                Pogoj za kreiranje napotnice je MF medical izvid
            </div>
            <hr class="m-2" />
        </ng-container>
        <div *ngIf="_data?.length > 0" class="mf-portfolio">
            <app-portfolio-list-item
                *ngFor="let element of _data?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)"
                [termData]="termData"
                [data]="element"
                [isReadOnly]="true"
                [type]="type"
                (onPrint)="openPreview($event, true)"
                (onPreview)="openPreview($event)"
                (onSend)="sendPaper($event)"
                (onSendCrpp)="sendPaperToCrpp($event)"
                (onStopCrppShare)="stopSharingDocumentToCrpp($event)"
                (onClick)="onClick($event.paperType, $event)"
                (redirect)="redirect($event)"
                (stopShare)="stopSharingDocument($event)"
                (attachToHD)="attachToHDChat($event)"
                (mergeWithDocumentClick)="onMergeWithDocument($event)"
                (renamePortfolioPaperClick)="renamePortfolioPaper($event)"
                class="document-element"
            ></app-portfolio-list-item>
            <ngb-pagination
                *ngIf="numberOfElements > itemsPerPage"
                [(page)]="currentPage"
                [collectionSize]="numberOfElements"
                [pageSize]="itemsPerPage"
                [directionLinks]="numberOfElements > itemsPerPage * 4"
                [maxSize]="2"
                class="d-flex justify-content-center align-self-end pt-2"
            ></ngb-pagination>
        </div>

        <div *ngIf="_data?.length < 1" class="p-1" i18n="@@2276116469383168">Ni listin.</div>
        <div class="m-widget3"></div>
    </div>
</div>
